<template>
    <div class="w-100">
        <v-card-title class="title font-weight-regular justify-space-between d-flex">
            &#xca;tes-vous sûr(e) de vouloir l'associer à un z de caisse ?
            <v-avatar
                color="primary lighten-2"
                class="subheading white--text"
                size="24"
                v-text="step"
                v-if="step"
            />
        </v-card-title>
        <!-- <v-card-text>
        </v-card-text> -->
        <v-card-actions v-if="!actions">
            <v-btn rounded @click="cancel()" style="margin: center" size="small">{{
                step ? "Précédent" : "Annuler"
            }}</v-btn>
            <v-spacer />
            <v-btn rounded @click="zTill" :loading="loading" size="small"
                >Oui, je suis sûr(e)</v-btn
            >
        </v-card-actions>
    </div>
</template>

<script lang="ts">
import { linkBankTransactionAccountingLineWithCashBox } from "../../services/reconciliationServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["added", "cancel"],
})
export class ZTill extends Vue {
    @Prop({ default: null }) step: any;
    @Prop({ default: null }) reconciliationVue: any;
    @Prop({ default: null }) zTillBT: any;
    @Prop({ default: null }) actions: any;

    loading: boolean = false;

    beforeMount() {
        if (this.actions) {
            this.actions.action.title = "Valider";
            this.actions.action.function = this.zTill;
            this.actions.action.loading = () => {
                return this.loading;
            };
        }
    }

    async zTill() {
        if (this.zTillBT) {
            this.loading = true;
            await linkBankTransactionAccountingLineWithCashBox(
                this.$apollo,
                this.zTillBT.bt,
                this.zTillBT.accountingLine,
            );
            await this.reconciliationVue.refresh();
            this.loading = false;
        }
        this.$emit("added");
    }

    cancel() {
        this.$emit("cancel");
    }
}

export default toNative(ZTill);
</script>
